import { render, staticRenderFns } from "./CategoriaV.vue?vue&type=template&id=0903523f"
import script from "./CategoriaV.vue?vue&type=script&lang=js"
export * from "./CategoriaV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports